import { AiCadFile } from './ai-cad-file.model';

export interface AiCadFiles {
    readonly orderFiles: AiCadFile[];
    readonly generatedFiles: AiCadFile[];
}
